import { render, staticRenderFns } from "./VentasArticuloFecha.vue?vue&type=template&id=2491224e&"
import script from "./VentasArticuloFecha.vue?vue&type=script&lang=js&"
export * from "./VentasArticuloFecha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports